<template>
    <!--EDI提单确认 -->
  <div class="page-container" id="EdiTemplate">
    <el-form
      ref="form"
      class="form-panel"
      label-position="top"
      :rules="searchDataFormRule"
             :model="searchData"
    >
      <el-row class="content-panel">

        <el-row :gutter="10">
        <el-col :span="5">
          <el-form-item label="导入类型:" prop="vgmResponsiblePerson">
          																<el-input size="mini" v-model="searchData.inputType" readonly></el-input>
          															</el-form-item>
        </el-col>

          <el-col :span="5">
            <el-form-item label="报文类型:" >
              <el-select
                style="width:100%;"
                v-model="searchData.ediType"

                size="mini"
               readonly
              >
                <el-option
                  v-for="item in isActiveOptions"
                  :key="item.key"
                  :label="item.value"
                  :value="item.key">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-row>
      <!-- 查询-end -->
    </el-form>
    <!-- 按钮栏-start -->
  <el-row class="content-panel title-fix" span="12" style="margin-top:15px">
  											<span class="span-text"><B style="color:black">选择报文</B></span>
     <el-upload
       class="upload-demo"
       drag
       action="https://jsonplaceholder.typicode.com/posts/"
       multiple>

         <div class="el-upload__text" style="  align-text: center;line-height:1000%">将Excel文件拖拽此处或<em>点击上传</em></div>

     </el-upload>
      <el-button type="info" size="small" plain @click="">保存</el-button>
      <el-button type="info" size="small" plain @click="">提交</el-button>

      <!-- 按钮栏-end -->
    </el-row>
    <!-- 表格-start -->
    <el-row style="margin-top: 15px">
      <hot-table
        ref="ebOrderTemplateTableRef"
        :data-source="ebOrderTemplateDataSource"
        :settings="tableSettings"
        @cellDblclick="tableCellClick"
        @rowDblclick="tableRowClick"
      >
        <hot-column :has-tip="true" data="ebOrderTemplateId" title="操作" width="120">
          <column-edit-renderer hot-renderer @clickModule="clickModule" />
        </hot-column>
        <hot-column :has-tip="true" data="orderRemark" title="备注" width="150" "/>
        <hot-column :has-tip="true" data="custBizNo" title="委托编号" width="150"/>
        <hot-column :has-tip="true" data="mblNo" title="提单号" width="150"/>
        <hot-column :has-tip="true" data="batchNo" title="批次号" width="150"/>
        <hot-column :has-tip="true" data="vesselNameEn" title="英文船名" width="150" />
        <hot-column :has-tip="true" data="voyage" title="出口航次" width="150" />\
        <hot-column :has-tip="true" data="fileName" title="文件名" width="150" />
      </hot-table>
      <!-- 分页start -->
      <!-- 分页start -->
      <div class="pg_div">
        <el-pagination
          :current-page="pageConfig.currentPage"
          :layout="pageConfig.layout"
          :page-size="pageConfig.pageSize"
          :page-sizes="pageConfig.pageSizes"
          :total="pageConfig.total"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        />
      </div>
      <!-- 分页end -->
    </el-row>
  </div>
</template>

<script>
  import { queryCarrierInfo, queryDictRows } from "@/api/commonService";
import ResizeObserver from "resize-observer-polyfill";
import ebOrderTemplate from "@/api/ebOrderTemplate";
import columnEditRenderer from "@/components/CustomRenderer/columnEditRenderer";
export default {
  components: {
    columnEditRenderer,
  },
  inject: ['reload'],
  data() {
    return {
      searchData: {
      inputType: "提单确认",
      ediType: "EXCEL格式",
      },
      readonly: true,
      searchDataFormRule: {

      },
      currentRow: {

      },
      ebOrderTemplateDataSource: [
        {
          ebOrderTemplateId: 1,
          isActive: 1,
          templateName: 1,
          carrierName: 1,
          creatorName: 1,
          createTime: '2021.1.1',
          lastModifierName: 1,
          lastModifyTime: '2021.1.1'
        }
      ],
      isActiveOptions: [
        {
          value: 'EXCEL格式',
          key: 1
        },

      ],

      // 表格设置
      tableSettings: {
        height: 320,
        stretchH: 'all', // 根据宽度横向扩展，last:只扩展最后一列，none：默认不扩展
        ...this.$systemConfig.tableConfig
      },
      // 分页
      pageConfig: {
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0,
        pageSize: 10,
        pagerCount: 10,
        currentPage: 1,
        pageSizes: [10, 20, 50, 100]
      },
      // 船公司联想控件
      associate_columns_carrier: [
        {
          title: "中文简称",
          field: 'custAlias'
        },
        {
          title: "中文全称",
          field: 'custNameCn'
        },
        {
          title: "助记码",
          field: 'mnemonicCode'
        }
      ],
      // 模板名称联想控件
      associate_columns_ebOrderTemplate: [
        {
          title: "模板名称",
          field: 'templateName'
        }
      ],
      //日期设置
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      shortcuts: [{
        text: '今天',
        onClick(picker) {
          picker.$emit('pick', new Date());
        }
      }, {
        text: '昨天',
        onClick(picker) {
          const date = new Date();
          date.setTime(date.getTime() - 3600 * 1000 * 24);
          picker.$emit('pick', date);
        }
      }, {
        text: '一周前',
        onClick(picker) {
          const date = new Date();
          date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
          picker.$emit('pick', date);
        }
      }]
    };
  },
  async created() {

  },
  mounted() {
    let self = this
    self.queryForm()
    self.queryEbOrderTemplateIsActive()
    // 监听外层容器div宽度的变化，做表格自适应
    self.resizeObserver = new ResizeObserver(entries => {
      self.$nextTick(() => {
        self.$refs.ebOrderTemplateTableRef.resizeTo(entries[0].target.clientWidth - 32)
      })
    })
    self.resizeObserver.observe(document.getElementById("EdiTemplate"))
  },
  beforeDestroy() {
    let _this = this
    // 离开页面删除检测器和所有侦听器
    _this.resizeObserver.disconnect();
  },
  methods: {
    // 船公司联想控件数据源
    associate_queryMethod_carrier({ keyword, pageSize, currentPage }) {
      let params = {}
      if (keyword === '') {
        params = {
          custType4: "%SO%",
          isDeleted6: "0"
        }
      } else {
        params = {
          custAlias0: "%" + keyword + "%",
          custNameCn1: "%" + keyword + "%",
          custType4: "%SO%",
          isDeleted6: "0",
          mdmCustCode3: "%" + keyword + "%",
          mnemonicCode2: "%" + keyword + "%",
        }
      }
      let data =
        {
          action: "query",
          crudType: "SELECT",
          sorting: ["CTS_ILPCsCust.custNameCn"],
          mainModelName: "CTS_ILPCsCust",
          tag: "CTS_WEB_es",
          where: "(((((CTS_ILPCsCust.custAlias LIKE :custAlias0 OR CTS_ILPCsCust.custNameCn LIKE :custNameCn1) ) AND CTS_ILPCsCust.esCustType LIKE :custType4) ) AND CTS_ILPCsCust.isDeleted = :isDeleted6)",
          currentPage: currentPage,
          pageSize: pageSize,
          returnPage: true,
          returnTotal: false,
          reqArgs: params,
          fields: [
            "CTS_ILPCsCust.csCustId",
            "CTS_ILPCsCust.custAlias",
            "CTS_ILPCsCust.custNameCn",
            "CTS_ILPCsCust.custNameEn",
            "CTS_ILPCsCust.customsRegisteredNo",
            "CTS_ILPCsCust.esCustType",
            "CTS_ILPCsCust.isActive",
            "CTS_ILPCsCust.isBlacklist",
            "CTS_ILPCsCust.isCustomer",
            "CTS_ILPCsCust.isDeleted",
            "CTS_ILPCsCust.isOneTimeCustomer",
            "CTS_ILPCsCust.isSettlement",
            "CTS_ILPCsCust.isSupplier",
            "CTS_ILPCsCust.legalPerson",
            "CTS_ILPCsCust.mdmCustCode",
            "CTS_ILPCsCust.mobileNo",
            "CTS_ILPCsCust.postCode"
          ],
          enableCascade: true
        }
      return new Promise(resolve => {
        queryCarrierInfo(data).then(res => {
          console.log("queryCarrierInfo", res)
          resolve({
            records: res.data.data,
            total: res.data.totalRecord
          })
        })
      }).catch(err => {
        console.log(err)
      })
    },
    // 模板名称联想控件数据源
    associate_queryMethod_ebOrderTemplate({ keyword, pageSize, currentPage }) {
      let params = {}
      params.templateName = keyword
      params.page = currentPage
      params.limit = pageSize
      return new Promise(resolve => {
        ebOrderTemplate.queryEbOrderTemplateName(params).then(res => {
          console.log(res)
          resolve({
            records: res.data.data,
            total: res.data.totalRecord
          })
        })
      }).catch(err => {
        console.log(err)
      })
    },
    // 重置
    resetForm() {
      this.searchData = {
        carrierName: '',
        templateName: '',
        startTime: '',
        endTime: '',
        isActive: ''
      }
    },

    // pageSize 改变时会触发
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
      this.pageConfig.pageSize = val
    },
    // currentPage 改变时会触发
    handleCurrentChange(val) {
      this.pageConfig.currentPage = val
    },
    tableCellClick(value) {
    },
    tableRowClick(value) {
      this.currentRow = value.record
      console.log('tableRowClick')
    },
    //点击
    clickModule(e) {
      const currentRow = this.currentRow
      console.log('currentRow',currentRow)
      if (currentRow.isActive) {
        this.$router.push({
          name: 'bookingAdd',
          params: {
            ebOrderTemplateId: currentRow.jsonInfo
          }
        })
      } else {
        this.$coreMethods.message('warning','请选择有效的记录。')
      }
    },

    // 获取数据字典
    getSelectList() {
      queryDictRows('MD_CODE_DICT$MD_CODE_YESNO').then(res => {
        /*name:value value:key*/
        console.log("queryDictRows:", res)
        //模板状态
        this.isActiveOptions = res.MD_CODE_DICT$MD_CODE_YESNO
        this.queryEbOrderTemplateIsActive()
      })
    },
    //模板状态数据字典
    queryEbOrderTemplateIsActive() {
      let dict = []
      this.isActiveOptions.forEach(item => {
        let param = {}
        param.name = item.value
        param.value = item.key === 1
        param.count = 0
        if (item.key !== 2) { dict.push(param) }
      })
      console.log("isActiveList", dict)
      // 数据字典
      this.$hotTableUtils.registDict({ 'EB_ORDER_TEMPLATENAME_ISACTIVE': dict })
    }
  }
};
</script>

<style scoped lang="less">

</style>
